// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    '已移動 ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => '命令',
  accControlKey: () => '關閉',
  accPositionAfter: () => '之後',
  accPositionBefore: () => '之前',
  accReorderInstructions: (p: { keyPressed: string }) =>
    '按住 ' + p['keyPressed'] + ' 加 shift 鍵, 然後使用方向鍵重新排列.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '輸入如以下範例的完整日期: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    '輸入如以下範例的月份與年度: ' + p['dateExample'] + '.',
  chart_labelGroup: () => '群組',
  chart_labelSeries: () => '數列',
  chart_labelValue: () => '值',
  checkboxSet_requiredMessageDetail: () => '必要',
  checkbox_requiredMessageDetail: () => '必要',
  close: () => '關閉',
  collection_noData: () => '沒有資料可供顯示.',
  collection_selectAllRows: () => '選取所有資料列',
  collection_selectRow: (p: { ROW_NAME: string }) => '選取 ' + p['ROW_NAME'] + ' 資料列',
  collection_sortDisabled: () => '不可排序',
  collection_sortEnabled: () => '可排序',
  confirmation: () => '確認',
  datePicker_currentDate: () => '目前的日期',
  datePicker_goToToday: () => '前往今天',
  datePicker_label: () => '日期選擇器',
  datePicker_month: () => '月',
  datePicker_months: () => '月',
  datePicker_next: () => '下一個',
  datePicker_nextDecade: () => '下一個十年',
  datePicker_nextMonth: () => '下個月',
  datePicker_prev: () => '上一個',
  datePicker_prevDecade: () => '上一個十年',
  datePicker_prevMonth: () => '上個月',
  datePicker_restricted: () => '受限制',
  datePicker_selected: () => '已選取',
  datePicker_today: () => '今天',
  datePicker_weekNum: (p: { NUM: string }) => '第 ' + p['NUM'] + ' 週',
  datePicker_weekNumColLabel: () => '週別',
  datePicker_year: () => '年',
  datePicker_years: () => '年',
  error: () => '錯誤',
  expandableList_expandCollapseInstructionText: () => '使用方向鍵展開與收合',
  expandableList_groupCollapse: () => '已收合',
  expandableList_groupExpand: () => '已展開',
  filePicker_addFiles: () => '新增檔案',
  filePicker_dropzonePrimaryText: () => '拖放',
  filePicker_dropzoneSecondaryText: () => '選取一個檔案或將一個檔案放到此處',
  filePicker_dropzoneSecondaryTextMultiple: () => '選取或將檔案放到此處',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    '您無法上傳以下類型的檔案: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => '一次上傳一個檔案',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    '您無法上傳 ' + p['fileType'] + ' 類型的檔案',
  filePicker_unknownFileTypeUploadError: () => '不明',
  formControl_clear: () => '清除',
  formControl_day: () => '日',
  formControl_helpAvailable: () => '提供說明',
  formControl_hide: () => '隱藏',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    '已達 ' +
    ((
      { one: new Intl.NumberFormat('zh-Hant').format(p['CHARACTER_LIMIT']) + ' 個字元' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('zh-Hant').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('zh-Hant').format(p['CHARACTER_LIMIT']) + ' 個字元') +
    '的限制.',
  formControl_loading: () => '載入中',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    '您最多可以輸入 ' + p['MAX_LENGTH'] + ' 個字元.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '還有 ' + p['CHARACTER_COUNT'] + ' 個字元.',
  formControl_month: () => '月',
  formControl_readOnly: () => '唯讀',
  formControl_requiredMessageDetail: () => '輸入值.',
  formControl_show: () => '顯示',
  formControl_year: () => '年',
  gantt_labelDate: () => '日期',
  gantt_labelEnd: () => '結束',
  gantt_labelLabel: () => '標籤',
  gantt_labelRow: () => '資料列',
  gantt_labelStart: () => '開始',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. 找不到符合的區段.',
  indexer_keyboardInstructionText: () => '按 Enter 鍵以選取值.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '在 ' + p['FROM_SECTION'] + ' 到 ' + p['TO_SECTION'] + ' 之間.',
  indexer_touchInstructionText: () => '點兩下並按住以進入手勢模式, 您可以上下拖曳來調整值.',
  info: () => '資訊',
  inputDateMask_date_cleared: () => '已清除日期',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => '空的',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    '輸入等於或早於 ' + p['max'] + ' 的日期.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    '輸入等於或晚於 ' + p['min'] + ' 的日期.',
  inputDatePicker_dateRestrictionMessageDetail: () => '輸入可用的日期.',
  inputDatePicker_instruction: () => '按 Tab 鍵即可存取行事曆.',
  inputDatePicker_selectDate: () => '選取日期',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    '輸入等於或早於 ' + p['max'] + ' 的月份與年度.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    '輸入等於或晚於 ' + p['min'] + ' 的月份與年度.',
  inputNumber_converterParseError: () => '輸入一個數字.',
  inputNumber_decrease: () => '減少',
  inputNumber_increase: () => '增加',
  inputPassword_hidden: () => '已隱藏密碼',
  inputPassword_hide: () => '隱藏密碼',
  inputPassword_show: () => '顯示密碼',
  inputSensitiveText_hidden: () => '隱藏機密文字',
  list_msgFetchCompleted: () => '已載入',
  list_msgFetchingData: () => '載入中',
  list_suggestion: () => '建議',
  messageToast_allMessagesClosed: () => '所有通知訊息都已關閉.',
  message_close: () => '關閉',
  message_confirmation: () => '成功',
  message_error: () => '錯誤',
  message_info: () => '資訊',
  message_navigationFromMessagesRegion: () => '進入訊息區域. 按 F6 即可回到先前聚焦的元素.',
  message_navigationToMessagesRegion: () => '訊息區域有新的訊息. 按 F6 即可瀏覽至最新的訊息區域.',
  message_warning: () => '警告',
  noData_message: () => '沒有可顯示的項目',
  overflowItemLabel: () => '其他頁籤',
  plural_separator: () => ', ',
  progressIndeterminate: () => '進行中',
  radio_helpForRadio: () => '圓鈕說明',
  radio_requiredMessageDetail: () => '選取一個值.',
  selectMultiple_apply: () => '套用',
  selectMultiple_back: () => '上一步',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () => '使用向左和向右方向鍵來標示選取的值.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    '按 Backspace 鍵或 Delete 鍵可移除選取的值.',
  selectMultiple_selectedValues: () => '選取的值',
  selectMultiple_showSelectedValues: () => '僅顯示選取的值.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '已選取 ' + p['VALUE_COUNT'] + ' 個值.',
  select_addToList: () => '新增至清單',
  select_addToListAvailable: () => '新增至清單可供使用',
  select_moreSearchOptions: () => '其他搜尋選項',
  select_moreSearchOptionsAvailable: () => '其他搜尋選項可供使用',
  select_noMatchesFound: () => '找不到相符項目.',
  select_oneMatchFound: () => '找到一個相符項目',
  select_requiredMessageDetail: () => '選取一個值.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => '找到 ' + p['TOTAL_SIZE'] + ' 個相符項目',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '找到 ' + p['TOTAL_SIZE'] + ' 個以上的相符項目',
  selectorAll_deselectAll: () => '取消全選',
  selectorAll_selectAll: () => '全選',
  selector_selected: () => '已勾選核取方塊',
  selector_unselected: () => '未勾選核取方塊',
  tabBarNavigationList_removeCueText: () => '可移除',
  timeComponent_tooltipZoomIn: () => '放大',
  timeComponent_tooltipZoomOut: () => '縮小',
  train_current: () => '目前',
  train_message_type: () => '訊息類型',
  train_not_visited: () => '未瀏覽',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '第 ' + p['currentStep'] + ' / ' + p['numberOfSteps'] + ' 個步驟',
  train_visited: () => '已瀏覽',
  userAssistance_learnMore: () => '進一步瞭解',
  userAssistance_required: () => '必要',
  vis_clearSelection: () => '清除選取範圍',
  vis_drillable: () => '可展開',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' / ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => '選框選取',
  vis_marqueeZoomTooltip: () => '選框放大',
  vis_noData: () => '沒有資料可供顯示',
  vis_panTooltip: () => '移動瀏覽',
  vis_stateLoaded: () => '已載入',
  vis_stateLoading: () => '載入中',
  vis_stateSelected: () => '已選取',
  vis_stateUnselected: () => '已取消選取',
  warn: () => '警告'
};
export default bundle;
